// components/admin/industries/IndustryForm.jsx
import React, { useEffect, useState } from 'react';
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Switch } from "../ui/switch";
import toast from "react-hot-toast";
const API = process.env.REACT_APP_API_BASE;

export default function IndustryForm({ editIndustry, onClose, onReload }) {

    const [formData, setFormData] = useState({
      name: '',
      displayName: '',
      description: '',
      icon: '',
      url: '',
      status: true
    });
  
    useEffect(() => {
      if (editIndustry) setFormData(editIndustry);
    }, [editIndustry]);
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData(prev => ({ ...prev, [name]: value }));
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      const method = editIndustry ? 'PUT' : 'POST';
      const url = editIndustry ? `${API}/api/industries/${editIndustry._id}` : `${API}/api/industries`;
  
      try {
        const res = await fetch(url, {
          method,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        });
        const updated = await res.json();
  
        if (res.ok) {
          toast.success(`Industry ${editIndustry ? 'updated' : 'created'} successfully`);
          onReload(updated);
          onClose();
        } else {
          toast.error(updated.error || 'Failed to save');
        }
      } catch (err) {
        toast.error('Server error');
      }
    };
  
    return (
      <form className="p-6 space-y-4" onSubmit={handleSubmit}>
        <Input name="name" value={formData.name} onChange={handleChange} placeholder="Industry (e.g., clinic)" required />
        <Input name="displayName" value={formData.displayName} onChange={handleChange} placeholder="Display Name (e.g., Clinic & Aesthetics)" required />
        <Input name="description" value={formData.description} onChange={handleChange} placeholder="Short Description" />
        <Input name="icon" value={formData.icon} onChange={handleChange} placeholder="Icon (e.g., 💅)" />
        <Input name="url" value={formData.url} onChange={handleChange} placeholder="Marketing URL (e.g., https://ennoverse.ai/clinics)" required />
        <div className="flex items-center justify-between">
          <label>Status</label>
          <Switch checked={formData.status} onCheckedChange={(val) => setFormData(prev => ({ ...prev, status: val }))} />
        </div>
        <Button type="submit" className="w-full">{editIndustry ? 'Update' : 'Create'} Industry</Button>
      </form>
    );
  }